import { Component, OnInit, Output, EventEmitter, TemplateRef, Input, ViewChild, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormControl } from '@angular/forms';
import { GeneralService } from '../../services/general.service';
import { environment } from '../../../environments/environment';
import { ICountry, IState, IGetPermissionMandatoryField } from '../interface';
import { UserSessionService } from '../../services/usersession.service';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { Subject } from 'rxjs';
import { CommonMethodService } from '../common-method.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';

@Component({
    selector: 'app-business-account',
    templateUrl: './business-account.component.html',
    styleUrls: ['./business-account.component.scss'],
    standalone: false
})
export class BusinessAccountComponent implements OnInit {
  businessAccountForm: FormGroup;
  private defaultCountryId = environment.defaultCountryId;
  public allowToCreatePortalLogin = environment.allowToCreatePortalLogin;
  countryList: ICountry[];
  companyDialinCode;
  modalRef: BsModalRef;
  modalRefCancel: BsModalRef;
  countrySelectedMilitary: number;
  stateList: IState[];
  public PhoneNumberMask: String = '(000)000-0000';
  public phoneNumberExtnMask: String = '(000)000-0000 x 000';
  @Output() BusinessAccInfo: EventEmitter<any> = new EventEmitter<any>();
  @Output() businessAccFilled: EventEmitter<any> = new EventEmitter<any>();
  businessInfoSaved = false;
  @Input() ContactInfo;
  @Input() matchingTenantContactDetails;
  @Input() AutoCreatePortalLogin;
  @Input() tenantId;
  @ViewChild('validateAccountExistsPortal', { static: true }) validateAccountExistsPortal: TemplateRef<any>;
  @ViewChild('BusinessAccountModal', { static: true }) BusinessAccountModal!: ModalDirective;
  businessInfoEmailSubject: Subject<any> = new Subject();
  portalLoginList = [];
  emailIdsPattern = '^([\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)([\,\;]{1}[\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)*$';
  noEmailSetting: any = false;
  companySettingDetails;
  defaultEmailBusinessInfo = false;
  existingauthenticationId = 0;
  existingPortalLoginId = 0;
  modalRefPortal: BsModalRef;
  emptyStateList = false;
  BusinessAccDetails;
  emailManuallyChanged : boolean = false;

  constructor(private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private userSessionService: UserSessionService,
    private facOpsDataService: FacOpsDataService,
    private prospectService: ProspectService,
    private modalWrapper: ModalWrapperService,
    private commonMethodService: CommonMethodService) { }

  ngOnInit() {
    this.allowToCreatePortalLogin = environment.allowToCreatePortalLogin;
    this.setMandatoryFieldforBusinessAcc();
    this.businessAccountForm = this.formBuilder.group({
      CompanyName: [''],
      FirstName: [''],
      MiddleName: [''],
      LastName: [''],
      CompanyAddress: [''],
      CompanyCity: [''],
      CompanyState: [''],
      CompanyZip: [''],
      CompanyCountryId: [''],
      CompanyPhoneCountryId: [''],
      CompanyPhone: [''],
      CompanyFaxCountryId: [''],
      CompanyFax: [''],
      CompanyEmail: [''],
      NoCompanyEmail: [''],
      SendEmailAlerts: [false]
    });

    if (this.ContactInfo) {
      this.businessAccountForm.patchValue({
        FirstName: this.ContactInfo.FirstName,
        LastName: this.ContactInfo.LastName,
        MiddleName: this.ContactInfo.MiddleName,
        SendEmailAlerts: this.ContactInfo.SendEmailAlerts
      });
    }
    this.companySettingDetails = this.userSessionService.InServiceGetCompanySettings();
    if (this.matchingTenantContactDetails) {
      this.BusinessAccDetails = {
        CompanyName: this.matchingTenantContactDetails.CompanyName ? this.matchingTenantContactDetails.CompanyName : '',
        CompanyAddress: this.matchingTenantContactDetails.CompanyAddress ? this.matchingTenantContactDetails.CompanyAddress : '',
        CompanyCity: this.matchingTenantContactDetails.CompanyCity ? this.matchingTenantContactDetails.CompanyCity : '',
        CompanyState: this.matchingTenantContactDetails.CompanyState ? this.matchingTenantContactDetails.CompanyState : '',
        CompanyZip: this.matchingTenantContactDetails.CompanyZip ? this.matchingTenantContactDetails.CompanyZip : '',
        CompanyCountryId: this.matchingTenantContactDetails.CompanyCountryId ? this.matchingTenantContactDetails.CompanyCountryId : this.defaultCountryId,
        CompanyPhoneCountryId: this.matchingTenantContactDetails.CompanyPhoneCountryId ? this.matchingTenantContactDetails.CompanyPhoneCountryId : this.defaultCountryId,
        CompanyPhone: this.matchingTenantContactDetails.CompanyPhone,
        CompanyFax: this.matchingTenantContactDetails.CompanyFax,
        CompanyFaxCountryId: this.matchingTenantContactDetails.CompanyFaxCountryId ? this.matchingTenantContactDetails.CompanyFaxCountryId : this.defaultCountryId,
        CompanyEmail: this.matchingTenantContactDetails.NoCompanyEmail ? this.companySettingDetails.General.GenericCustomerEmailAddress : this.matchingTenantContactDetails.CompanyEmail,
        NoCompanyEmail: this.matchingTenantContactDetails.NoCompanyEmail,
        MiddleName: this.matchingTenantContactDetails.MiddleName ? this.matchingTenantContactDetails.MiddleName : '',
      };
    }
    this.updateSendEmailAlerts();
    this.getCountries();
    this.loadBusinessdetails();
    this.businessInfoEmailSubject.pipe(debounceTime(1000),distinctUntilChanged()).subscribe(event => {
      this.onChangeEmail(event);
    });
    this.getPortalLoginList();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tenantId']) {
      this.getPortalLoginList();
    }
     if (changes['ContactInfo']) {
      this.updateSendEmailAlerts();
     }
  }

  updateSendEmailAlerts(){
      if (!this.businessAccountForm) {
    return;
  }
                this.businessAccountForm.patchValue({
        SendEmailAlerts: this.ContactInfo.SendEmailAlerts
      });
          if(this.ContactInfo.Email?.trim() || (this.matchingTenantContactDetails?.CompanyEmail?.trim() || this.businessAccountForm.get('CompanyEmail').value?.trim())){
 this.businessAccountForm.get('SendEmailAlerts').enable();
    }
    else{
      this.businessAccountForm.patchValue({SendEmailAlerts: false});
       this.businessAccountForm.get('SendEmailAlerts').disable();

    }
     this.emailManuallyChanged = false;
  }

  loadBusinessdetails() {
    if (this.BusinessAccDetails) {
      this.businessAccountForm.patchValue({
        CompanyName: this.BusinessAccDetails.CompanyName,
        CompanyAddress: this.BusinessAccDetails.CompanyAddress,
        CompanyCity: this.BusinessAccDetails.CompanyCity,
        CompanyState: this.BusinessAccDetails.CompanyState,
        CompanyZip: this.BusinessAccDetails.CompanyZip,
        CompanyCountryId: this.BusinessAccDetails.CompanyCountryId,
        CompanyPhoneCountryId: this.BusinessAccDetails.CompanyPhoneCountryId,
        CompanyPhone: this.BusinessAccDetails.CompanyPhone,
        CompanyFax: this.BusinessAccDetails.CompanyFax,
        CompanyFaxCountryId: this.BusinessAccDetails.CompanyFaxCountryId,
        CompanyEmail: this.BusinessAccDetails.NoCompanyEmail ? this.companySettingDetails.General.GenericCustomerEmailAddress : this.BusinessAccDetails.CompanyEmail,
        NoCompanyEmail: this.BusinessAccDetails.NoCompanyEmail,
        MiddleName: this.BusinessAccDetails.MiddleName
      });
      const businessaccObj ={
        CompanyName: this.BusinessAccDetails.CompanyName,
        CompanyAddress: this.BusinessAccDetails.CompanyAddress,
        CompanyCity: this.BusinessAccDetails.CompanyCity,
        CompanyState: this.BusinessAccDetails.CompanyState,
        CompanyZip: this.BusinessAccDetails.CompanyZip,
        CompanyCountryId: this.BusinessAccDetails.CompanyCountryId,
        CompanyPhoneCountryId: this.BusinessAccDetails.CompanyPhoneCountryId,
        CompanyPhone: this.BusinessAccDetails.CompanyPhone,
        CompanyFax: this.BusinessAccDetails.CompanyFax,
        CompanyFaxCountryId: this.BusinessAccDetails.CompanyFaxCountryId,
        CompanyEmail: this.BusinessAccDetails.NoCompanyEmail ? this.companySettingDetails.General.GenericCustomerEmailAddress : this.BusinessAccDetails.CompanyEmail,
        NoCompanyEmail: this.BusinessAccDetails.NoCompanyEmail,
        FirstName: this.businessAccountForm.value.FirstName,
        MiddleName: this.businessAccountForm.value.MiddleName,
        LastName: this.businessAccountForm.value.LastName,
        IsMakeEmailPortalLogin: this.ContactInfo?.IsMakeEmailPortalLogin,
        AuthenticationId: this.ContactInfo?.AuthenticationId,
        ExistingPortalLoginId: this.ContactInfo?.ExistingPortalLoginId,
        SendEmailAlerts: this.ContactInfo?.SendEmailAlerts
      }
      this.businessInfoSaved = true;
      this.businessAccFilled.emit(true);
      this.BusinessAccInfo.emit(businessaccObj);
      if (this.BusinessAccDetails.NoCompanyEmail) {
        this.businessAccountForm.get('CompanyEmail').disable();
      }
    }
  }

  OnBusinessaccCancel() {
    this.modalRefCancel.hide();
    this.closeBusinessAccountModal();
    this.businessAccountForm.reset();
    if (this.matchingTenantContactDetails && this.matchingTenantContactDetails.BusinessAccount) {
      this.businessAccountForm.patchValue({
        FirstName: this.ContactInfo.FirstName,
        LastName: this.ContactInfo.LastName,
        MiddleName: this.ContactInfo.MiddleName,
        CompanyName: this.BusinessAccDetails.CompanyName,
        CompanyAddress: this.BusinessAccDetails.CompanyAddress,
        CompanyCity: this.BusinessAccDetails.CompanyCity,
        CompanyState: this.BusinessAccDetails.CompanyState,
        CompanyZip: this.BusinessAccDetails.CompanyZip,
        CompanyCountryId: this.BusinessAccDetails.CompanyCountryId,
        CompanyPhoneCountryId: this.BusinessAccDetails.CompanyPhoneCountryId,
        CompanyPhone: this.BusinessAccDetails.CompanyPhone,
        CompanyFax: this.BusinessAccDetails.CompanyFax,
        CompanyFaxCountryId: this.BusinessAccDetails.CompanyFaxCountryId,
        CompanyEmail: this.BusinessAccDetails.NoCompanyEmail ? this.companySettingDetails.General.GenericCustomerEmailAddress : this.BusinessAccDetails.CompanyEmail,
        NoCompanyEmail: this.BusinessAccDetails.NoCompanyEmail,
        SendEmailAlerts: this.ContactInfo.SendEmailAlerts
      });
    }
  }

  onBusinessFormCountryChange(obj) {
    if (obj == 1 || obj == 2) {
      this.emptyStateList = false;
      this.businessAccountForm.patchValue({ CompanyState: '' });
      this.businessAccountForm.get('CompanyState').enable();
      this.getStates(obj);
    } else {
      this.emptyStateList = true;
      this.stateList = [];
      this.businessAccountForm.patchValue({ CompanyState: '0' });
      this.businessAccountForm.get('CompanyState').disable();
    }
    this.updateDialInCode(obj);
  }

  updateDialInCode(id) {
    this.companyDialinCode = this.countryList.find(O => O.Id == id).Id;
    this.businessAccountForm.patchValue({
      CompanyPhoneCountryId: this.companyDialinCode,
      CompanyFaxCountryId: this.companyDialinCode
    });
  }

  IsBusinessaccvalid() {
    if (this.businessAccountForm.valid && this.businessAccountForm.dirty) {
      return false;
    } else {
      return true;
    }
  }

  public onStartfocus(args): void {
    args.selectionStart = 1;
    args.selectionEnd = 1;
  }

  getCountries() {
    this.generalService.getCountries().subscribe((response: ICountry[]) => {
      this.countryList = response;
      if (!this.matchingTenantContactDetails) {
        this.businessAccountForm.patchValue({
          CompanyCountryId: environment.defaultCountryId
        });
      this.onBusinessFormCountryChange(environment.defaultCountryId);
      }
      else{
         this.getStates(this.BusinessAccDetails?.CompanyCountryId);
      }
      this.businessAccountForm.markAsUntouched();
      this.businessAccountForm.markAsPristine();
    });
  }

  getStates(id) {
    this.generalService.getStates(id).subscribe((response: IState[]) => {
      this.stateList = response;
      this.businessAccountForm.patchValue({
        CompanyState: this.businessAccountForm.get('CompanyState').value ? this.businessAccountForm.get('CompanyState').value :
          id == 1 || id == 2 ? '' : '0'
      })
    });
  }

  public cellPhoneValidator(control: FormControl) {
    if ((control.value !== '') && (control.value !== null)) {
      if (control.value) {
        const isWhitespace = (control.value).trim().length < 10;
        const isValid = !isWhitespace;
        return isValid ? null : { 'lessThanTen': true };
      }
    }
  }

  isRequired(control) {
    if (this.businessAccountForm.get(control).validator !== null) {
      const validator = this.businessAccountForm.get(control).validator({} as AbstractControl);
      return validator && validator.required ? true : false;
    } else {
      return false;
    }
  }

  setMandatoryFieldforBusinessAcc() {
    this.generalService.GetMandatoryFieldsById(this.userSessionService.userSessionData.LastAccessedStoreId, 146)
      .subscribe((response: IGetPermissionMandatoryField) => {
        var data = response;
        if (data.Form.ListOfProperties.length != 0) {
          data.Form.ListOfProperties.forEach(field => {
            if (field.Name == 'CompanyFirstName') {
              field.Name = 'FirstName';
            }
            if (field.Name == 'CompanyMiddleName') {
              field.Name = 'MiddleName';
            }
            if (field.Name == 'CompanyLastName') {
              field.Name = 'LastName';
            }
            if (field.Name == 'CompanyPhone' || field.Name == 'CompanyFax') {
              if (field.Required) {
                this.businessAccountForm.get(field.Name).setValidators([this.cellPhoneValidator, Validators.required]);
              } else {
                this.businessAccountForm.get(field.Name).setValidators([this.cellPhoneValidator]);
              }
            } else if (field.Name == 'CompanyEmail') {
              if (field.Required) {
                this.businessAccountForm.get(field.Name).setValidators([Validators.pattern(this.emailIdsPattern), Validators.required]);
              } else {
                this.businessAccountForm.get(field.Name).setValidators(Validators.pattern(this.emailIdsPattern));
              }
            } else if (field.Required) {
              this.businessAccountForm.get(field.Name).setValidators([Validators.required]);
            } else {
              this.businessAccountForm.get(field.Name).setValidators(null);
            }
            this.businessAccountForm.get(field.Name).updateValueAndValidity();
          });
        }
      });
  }

  businessAccountSubmit() {
    this.businessAccountForm.markAsUntouched();
    var businessaccObj = {
      CompanyName: this.businessAccountForm.value.CompanyName,
      CompanyAddress: this.businessAccountForm.value.CompanyAddress,
      CompanyCity: this.businessAccountForm.value.CompanyCity,
      CompanyState: this.businessAccountForm.value.CompanyState,
      CompanyZip: this.businessAccountForm.value.CompanyZip,
      CompanyCountryId: this.businessAccountForm.value.CompanyCountryId,
      CompanyPhoneCountryId: this.businessAccountForm.value.CompanyPhoneCountryId,
      CompanyPhone: this.businessAccountForm.value.CompanyPhone,
      CompanyFaxCountryId: this.defaultCountryId,
      CompanyFax: this.businessAccountForm.value.CompanyFax,
      CompanyEmail: this.businessAccountForm.value.CompanyEmail,
      CompanyNoEmail: this.businessAccountForm.value.CompanyNoEmail,
      FirstName: this.businessAccountForm.value.FirstName,
      MiddleName: this.businessAccountForm.value.MiddleName,
      LastName: this.businessAccountForm.value.LastName,
      IsMakeEmailPortalLogin: this.defaultEmailBusinessInfo,
      AuthenticationId: this.existingauthenticationId,
      ExistingPortalLoginId: this.existingPortalLoginId,
      SendEmailAlerts: this.businessAccountForm.value.SendEmailAlerts
    }
    this.businessInfoSaved = true;
    this.businessAccFilled.emit(this.businessInfoSaved);
    this.BusinessAccInfo.emit(businessaccObj);
    this.setBusinessAccService = businessaccObj;
      this.emailManuallyChanged = false;
  }

  openModal() {
    this.modalWrapper.openDirective(this.BusinessAccountModal);
  }

  closeBusinessAccountModal() {
    this.BusinessAccountModal.hide();
  }

  businessAccountSubmitAndClose() {
    this.businessAccountSubmit();
    this.closeBusinessAccountModal();
  }

  reopenBusinessAccountModal() {
    this.modalRefCancel.hide();
    this.openModal();
  }

  onEmailCheckboxChange() {
  this.emailManuallyChanged = true;
}
onBlurFunction(){
  const email = (this.businessAccountForm.get('CompanyEmail').value || '').trim();
  const isValidEmail = email && this.businessAccountForm.get('CompanyEmail').valid;
  if (isValidEmail && !this.emailManuallyChanged) {
    this.businessAccountForm.patchValue({
      SendEmailAlerts: true
    });
           this.businessAccountForm.get('SendEmailAlerts').enable();

  }
  else{
    if(!(this.ContactInfo.Email?.trim())){
      this.businessAccountForm.patchValue({SendEmailAlerts: false});
       this.businessAccountForm.get('SendEmailAlerts').disable();
    }
  }
}
  get getBusinessAccService() {
    return this.facOpsDataService.BusinessAccInfo;
  }

  set setBusinessAccService(value) {
    this.facOpsDataService.BusinessAccInfo = value;
  }

  onOpenCancelPOPUPforBusiness(template: TemplateRef<any>) {
    if (this.businessAccountForm.dirty) {
      this.closeBusinessAccountModal();
      this.modalRefCancel = this.modalWrapper.openTemplate(template, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
    } else {
      this.businessAccountForm.markAsPristine();
      this.businessAccountForm.markAsUntouched();
      this.closeBusinessAccountModal();
    }
  }

  clearForm() {    
    this.businessAccountForm.reset();    
    this.businessAccountForm.patchValue({
      CompanyCountryId: environment.defaultCountryId,
    });
    this.onBusinessFormCountryChange(this.defaultCountryId);
    this.businessInfoSaved = false;
    this.businessAccFilled.emit(this.businessInfoSaved);
    if (this.ContactInfo) {
      this.businessAccountForm.patchValue({
        FirstName: this.ContactInfo.FirstName,
        LastName: this.ContactInfo.LastName,
        MiddleName: this.ContactInfo.MiddleName
      });
    }
    this.defaultEmailBusinessInfo = false;
    this.businessAccountForm.get('SendEmailAlerts').disable();
    var businessaccObj = {
      FirstName: this.businessAccountForm.value.FirstName,
      MiddleName: this.businessAccountForm.value.MiddleName,
      LastName: this.businessAccountForm.value.LastName,
      CompanyName: null,
      CompanyAddress: null,
      CompanyCity: null,
      CompanyState: null,
      CompanyZip: null,
      CompanyCountryId: this.businessAccountForm.value.CompanyCountryId,
      CompanyPhoneCountryId: this.defaultCountryId,
      CompanyPhone: null,
      CompanyFaxCountryId: this.defaultCountryId,
      CompanyFax: null,
      CompanyEmail: null,
      CompanyNoEmail: false,
      IsMakeEmailPortalLogin: false,
      AuthenticationId: 0,
      ExistingPortalLoginId: 0,
      SendEmailAlerts: false
    }
    this.BusinessAccInfo.emit(businessaccObj);
  }

  onChangeNoEmail(eve) {
    this.noEmailSetting = eve.target.checked;
    if (this.noEmailSetting) {
      this.defaultEmailBusinessInfo = false;
      this.businessAccountForm.patchValue({
        CompanyEmail: this.companySettingDetails.General.GenericCustomerEmailAddress,
      })
      this.businessAccountForm.get('CompanyEmail').disable();
      if(!(this.ContactInfo.Email?.trim() && this.ContactInfo.SendEmailAlerts == true)){
            this.businessAccountForm.patchValue({SendEmailAlerts: false});
       this.businessAccountForm.get('SendEmailAlerts').disable();
      }
    } else {
      this.businessAccountForm.patchValue({
        CompanyEmail: '',
      })
      this.businessAccountForm.get('CompanyEmail').enable();
            this.businessAccountForm.patchValue({SendEmailAlerts: false});
       this.businessAccountForm.get('SendEmailAlerts').enable();
    }
  }

  restrictSpace(eve) {
    if (eve.which === 32) {
      eve.preventDefault();
    }
  }

  makePortalLogin(userName, event) {
    this.existingPortalLoginId = 0;
    this.existingauthenticationId = 0;
    let emailObj = {
      EmailId: userName
    }
    if (event.target.checked) {
      this.prospectService.CheckTenantEmailB2CAccountExists(emailObj).subscribe((response) => {
        if (response.Exists) {
          let existingObject = this.checkIfPortalLoginExistsInList(emailObj.EmailId)
          if (!existingObject) {
            this.existingauthenticationId = response.ObjectId;
            this.openModalPortal(this.validateAccountExistsPortal);
          } else {
            this.existingPortalLoginId = existingObject.Id;
            this.existingauthenticationId = response.ObjectId;
          }
        }
      });
    }
  }

  openModalPortal(template: TemplateRef<any>) {
    this.modalRefPortal = this.modalWrapper.openTemplate(template, { class: "modal-dialog-centered", backdrop: 'static', keyboard: false });
  }

  makeAsUnchecked() {
    this.defaultEmailBusinessInfo = false;
    this.modalRefPortal.hide();
  }

  addToPortalLoginList() {
    this.defaultEmailBusinessInfo = true;
    this.modalRefPortal.hide();
  }

  onChangeEmail(value) {
    this.existingPortalLoginId = 0;
    this.existingauthenticationId = 0;
    let emailAddress = !this.businessAccountForm.get('CompanyEmail').value ? '' : this.businessAccountForm.get('CompanyEmail').value;
    if (this.businessAccountForm.get('NoCompanyEmail').value == true) {
      emailAddress = '';
    }
    if (emailAddress.trim().length == 0 || !this.businessAccountForm.get('CompanyEmail').valid) {
      this.defaultEmailBusinessInfo = false;
    }

    if (emailAddress.trim().length !== 0 && this.businessAccountForm.get('CompanyEmail').valid) {
      if (this.allowToCreatePortalLogin && this.AutoCreatePortalLogin) {
        this.defaultEmailBusinessInfo = true;
      }
    } else {
      this.defaultEmailBusinessInfo = false;
    }

    let emailObj = {
      EmailId: emailAddress
    }
    if (this.defaultEmailBusinessInfo) {
      this.prospectService.CheckTenantEmailB2CAccountExists(emailObj).subscribe((response) => {
        if (response.Exists) {
          let existingObject = this.checkIfPortalLoginExistsInList(emailObj.EmailId)
          if (!existingObject) {
            this.existingauthenticationId = response.ObjectId;
            this.openModalPortal(this.validateAccountExistsPortal);
          } else {
            this.existingPortalLoginId = existingObject.Id;
            this.existingauthenticationId = response.ObjectId;
          }
        }
      });
    }
  }

  getPortalLoginList() {
    this.portalLoginList = [];
    if (this.tenantId) {
      this.prospectService.GetPortalLoginDetails(this.tenantId,this.userSessionService.userSessionData.LastAccessedStoreId).subscribe((res) => {
        if (res && res.length) {
          this.portalLoginList = res.filter((item) => !item.DeleteFlag);
        }
      }, err => {
      });
    }
  }

  checkIfPortalLoginExistsInList(EmailId) {
    var isExisting = false;
    let existingObject = this.portalLoginList.find((item) => item.Id && (item.UserName == EmailId));
    return isExisting = existingObject ? existingObject : false;
  }

  validateZipInput(eve){
    this.commonMethodService.validateZipInput(eve);
  }
}
